import { useDispatch } from 'react-redux';
import { useMutation } from 'react-query';
import { useRef, useState } from 'react';
import { uiActions } from '../../store/ui-slice';
import { contactUs } from '../../api/questionsAPI';
import useInput from '../../hooks/use-input';
import Button from '../ui/Button';

import './ContactUsForm.scss';

const ContactUsForm = () => {
	const {
		value: enteredName,
		isValid: enteredNameIsValid,
		hasError: nameInputHasError,
		valueChangeHandler: nameChangedHandler,
		inputBlurHandler: nameBlurHandler,
		reset: resetNameInput
	} = useInput((value) => value.trim() !== '');

	const {
		value: enteredEmail,
		isValid: enteredEmailIsValid,
		hasError: emailInputHasError,
		valueChangeHandler: emailChangedHandler,
		inputBlurHandler: emailBlurHandler,
		reset: resetEmailInput
	} = useInput((value) => value.trim() !== '');

	const dispatch = useDispatch();

	const authMutation = useMutation((contactUsData) => {
		return contactUs(contactUsData);
	});
	const [textAreaCount, setTextAreaCount] = useState(0);
	const [showError, setShowError] = useState(false);

	const messageRef = useRef();

	const recalculateText = (e) => {
		setTextAreaCount(e.target.value.length);
	};

	let formIsValid = false;

	if (enteredNameIsValid && enteredEmailIsValid) {
		formIsValid = true;
	}
	const nameInputClasses = nameInputHasError
		? 'form-control is-invalid'
		: 'form-control';

	const emailInputClasses = emailInputHasError
		? 'form-control is-invalid'
		: 'form-control';

	const sendDataHandler = (event) => {
		event.preventDefault();
		const name = enteredName;
		const email = enteredEmail;
		const message = messageRef.current.value;

		if (!message) {
			setShowError(true);
			return;
		}

		authMutation.mutate(
			{
				name: name,
				email: email,
				message: message
			},
			{
				onSuccess: () => {
					dispatch(
						uiActions.launchNotification({
							title: 'The info has been sent successfuly',
							message:
								'The message has been sent to our team, in the next hours we will be answering you.',
							status: 'success'
						})
					);
					messageRef.current.value = '';
					setTextAreaCount(0);
				},
				onError: (error) => {
					dispatch(
						uiActions.launchNotification({
							title: 'The information has not been sent',
							message:
								'An unexpected error has ocurred, please try again!',
							status: 'error'
						})
					);
					messageRef.current.value = '';
				}
			}
		);
		resetNameInput();
		resetEmailInput();
		setShowError(false);
	};
	return (
		<>
			<div className='contact-us-container '>
				<h4>Contact Us</h4>
				<form>
					<div className='control-container row'>
						<div className='col-sm-6'>
							<label htmlFor='name'>Name</label>
							<input
								id='name'
								type='text'
								placeholder='John Smith'
								onChange={nameChangedHandler}
								onBlur={nameBlurHandler}
								className={nameInputClasses}
							/>
						</div>
						<div className='col-sm-6'>
							<label htmlFor='email'>Email</label>
							<input
								id='email'
								type='text'
								placeholder='example@gmail.com'
								onChange={emailChangedHandler}
								onBlur={emailBlurHandler}
								className={emailInputClasses}
							/>
						</div>
					</div>
					<div className='control-container'>
						<label htmlFor='message'>Message</label>
						<textarea
							id='message'
							type='text'
							className='contact-us-message form-control'
							ref={messageRef}
							onChange={recalculateText}
							maxLength={1000}
						></textarea>
						<div className='textbox-footer'>
							<p className='text-area-count'>
								{textAreaCount}/1000
							</p>
							{showError && (
								<p className='error-text'>
									Message must not be empty
								</p>
							)}
						</div>
					</div>
					<div className='contac-us-button'>
						<Button
							onClick={sendDataHandler}
							className='primary-button'
							disabled={!formIsValid}
						>
							Send
						</Button>
					</div>
				</form>
			</div>
		</>
	);
};

export default ContactUsForm;
